import { render, staticRenderFns } from "./CompanyCorrEmail.vue?vue&type=template&id=2bc06ab4&scoped=true&"
import script from "./CompanyCorrEmail.vue?vue&type=script&lang=js&"
export * from "./CompanyCorrEmail.vue?vue&type=script&lang=js&"
import style0 from "./CompanyCorrEmail.vue?vue&type=style&index=0&id=2bc06ab4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc06ab4",
  null
  
)

export default component.exports